const imaging =
[
    {symptom:"cxrLung",
    displayAs:"Chest XR / CT suggesting lung cancer",
    questionGroup: "imagingQuestions"
    },
    
    {symptom:"cxrPleural",
    displayAs:"Chest XR / CT suggesting pleural disease",
    questionGroup: "imagingQuestions"
    },

    {symptom:"imagingOvarian",
    displayAs: "Ultrasound / CT suspicious of ovarian cancer",
    questionGroup: "imagingQuestions"
    },   

    {symptom:"imagingEndometrial",
    displayAs: "Ultrasound / CT suspicious of endometrial cancer",
    questionGroup: "imagingQuestions"
    },

    {symptom:"xrBoneSarcoma",
    displayAs:"X Ray suggesting bone sarcoma",
    questionGroup: "imagingQuestions"
    },

    {symptom: "usSarcoma",
    displayAs: "Ultrasound suggesting / inconclusive for sarcoma",
    questionGroup: "imagingQuestions"
    }

]

export default imaging